// extracted by mini-css-extract-plugin
module.exports = {"card":"TimeLoggedGraph_card__3yiWN","noTimeLogImg":"TimeLoggedGraph_noTimeLogImg__FxtwL","loaderOverlay":"TimeLoggedGraph_loaderOverlay__2bm6y"};